import ApplicationView from './Application.view';
export * from './Application.view';

export const Application = (props) => ApplicationView(props);

export default Application;

